module.exports = __webpack_public_path__ + "static/Twitch-Banner-3526f0ad93af2e2ba3c04cd6eeee44f9.png";